// extracted by mini-css-extract-plugin
export default {"customLabel":"ListCharacteristicsValuesItem_customLabel__bolue","checked":"ListCharacteristicsValuesItem_checked__Lmw5L","limit":"ListCharacteristicsValuesItem_limit__OorzC"};